import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { useForm, Controller } from 'react-hook-form';

import adminSetupService from '../../services/SetupService';
import { Button, Paper } from '@material-ui/core';
import toast from 'react-hot-toast';
import AlertDialog from './AlertDialog';

const qualificationList = [
  'OH&S (White Card)',
  'Driver License',
  'Working With Children',
  'Long Service Leave',
  'Superannuation',
  'Police Check',
  'VBA License(Plumbing)',
  'Redundancy',
  'First Aid',
  'Refrigeration Handling Licence',
  'Plant Licence',
  'EWP (Scizzor lift)',
  'Union Card',
  'A Grade'
];

const qualificationOptions = qualificationList.map((qItem) => {
  return { value: qItem, label: qItem };
});

const MandatoryQualificationSetup = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [alertDialogOpen, setAlertDialogOpen] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [allEmployeeChecked, setAllEmployeeChecked] = useState(false);

  const { handleSubmit, control, reset } = useForm({ defaultValues: { qualifications: [] } });

  const handleClose = () => {
    setAlertDialogOpen(false);
    setSelectedEmployees([]);
    setAllEmployeeChecked(false);
  };

  useEffect(() => {
    const fetchAdminSetup = async () => {
      try {
        const response = await adminSetupService.getAdminSetup();

        const defaultMandatoryQualification = response?.data?.data?.[0]?.defaultMandatoryQualification || [];

        const defaultQualsArray = defaultMandatoryQualification?.map((qual) => {
          return { value: qual, label: qual };
        });

        // Set the default values on the form
        reset({ qualifications: defaultQualsArray });
      } catch (error) {
        toast.error(
          error?.response?.data?.message || error?.message || 'Could not fetch default mandatory qualifications'
        );
      }
    };
    fetchAdminSetup();
  }, [reset]);

  const onSave = (data) => {
    setFormData(data);
    setAlertDialogOpen(true);
  };

  const handleContinue = async () => {
    setLoading(true);
    try {
      const selectedQualification = formData.qualifications.map((qItem) => qItem.value);

      let adminSetupPayload = {
        defaultMandatoryQualification: selectedQualification
      };

      if (allEmployeeChecked) {
        adminSetupPayload = { ...adminSetupPayload, allEmployeeChecked: true };
      } else if (selectedEmployees.length > 0) {
        const employeeIds = selectedEmployees.map((employee) => employee.value);
        adminSetupPayload = { ...adminSetupPayload, employeeIds: employeeIds };
      }

      await adminSetupService.createAdminSetup(adminSetupPayload);
      handleClose();

      toast.success('Successfully saved default mandatory qualifications');
    } catch (error) {
      toast.error(
        error?.response?.data?.message || error?.message || 'Could not save default mandatory qualifications'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Paper style={{ padding: '1rem' }}>
        <form onSubmit={handleSubmit(onSave)}>
          <h3>Default Mandatory Qualifications</h3>
          <Controller
            name="qualifications"
            control={control}
            render={({ field }) => (
              <ReactSelect
                {...field}
                closeMenuOnSelect={false}
                isMulti
                options={qualificationOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                // eslint-disable-next-line no-undef
                menuPortalTarget={document.body}
              />
            )}
          />

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
            <Button type="submit" color="primary" variant="contained">
              Save
            </Button>
          </div>
        </form>
      </Paper>

      <AlertDialog
        open={alertDialogOpen}
        handleClose={handleClose}
        loading={loading}
        handleContinue={handleContinue}
        selectedEmployees={selectedEmployees}
        setSelectedEmployees={setSelectedEmployees}
        allEmployeeChecked={allEmployeeChecked}
        setAllEmployeeChecked={setAllEmployeeChecked}
      />
    </div>
  );
};

export default MandatoryQualificationSetup;
